/**
 * Reusable "under construction" placeholder component.
 * Displayed on pages that have not yet been implemented.
 *
 * @module components/UnderConstruction
 */

import React              from 'react';
import { Construction }  from 'lucide-react';
import { useI18n }       from '../dataProviders/I18nProvider';

/**
 * Renders a centered card with a construction icon and message.
 *
 * @returns {React.ReactElement}
 */
export default function UnderConstruction() {
  const { t } = useI18n();

  return (
    <div className="under-construction">
      <Construction size={64} className="under-construction-icon" />
      <h2 className="under-construction-title">{t('underConstruction.title')}</h2>
      <p className="under-construction-message">{t('underConstruction.message')}</p>
    </div>
  );
}
